import React from "react";
import AboutComponent from "../Components/About/AboutComponent";
import NavBar from "../Components/NavBar/NavBar";

function About(props) {
  return (
    <>
      <NavBar />
      <AboutComponent />
    </>
  );
}

export default About;
